import useOpenMatches from './useOpenMatches'

// De open twijfelgevallen van de koppeling op adres (AddressMatches, Status
// 'open') voor de conflictenlijst op het dashboard en de melding bij een
// huishouden. De logica (laden/leeg/fout, nieuwste eerst) staat in
// useOpenMatches, gedeeld met de kaart 'Deelnemers om te koppelen'.
// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md

/**
 * @returns {{matches: Array<object>, loaded: boolean, error: Error|null}}
 */
const useAddressMatches = () => useOpenMatches('AddressMatches')

export default useAddressMatches
